/*
 * How fast each kind of way is travelled, by mode. The graph stores only
 * codes (class, surface, track grade, sac_scale; scripts/routing/profiles.py),
 * so these numbers can be tuned here without rebuilding it.
 *
 * Costs are seconds. A route's cost is the time to drive, park and walk.
 */
export const CLASS = {
  motorway: 0, trunk: 1, primary: 2, secondary: 3, tertiary: 4, unclassified: 5, residential: 6, service: 7,
  living_street: 8, track: 9, path: 10, footway: 11, steps: 12, pedestrian: 13, bridleway: 14, cycleway: 15,
};
export const SURFACE = { unknown: 0, paved: 1, compacted: 2, gravel: 3, dirt: 4, sand: 5, rough: 6 };

//: km/h on a road of each class, for a car (index = class code).
const ROAD_KMH = [100, 80, 70, 60, 50, 40, 30, 20, 10, 30, 0, 0, 0, 0, 0, 0];
//: km/h on a track by grade (0 = not graded) for a 4x4.
const TRACK_KMH_4X4 = [12, 30, 25, 20, 15, 12];

export const WALK_KMH = 4.5;
export const STEPS_KMH = 2.5;
//: Walking on a marked trail costs this much of the time on an unmarked way:
//: a marked trail is preferred, not a detour for its own sake.
export const TRAIL_FACTOR = 0.85;
//: Walking along a busy road is allowed, and avoided.
export const BUSY_ROAD_FACTOR = 1.3;
//: Off any path: from the last path to the target, and from the start to the first way.
export const OFFTRAIL_KMH = 2.5;
//: Leaving the car: parking, locking, finding the start of the path.
export const PARK_S = 120;
//: The fastest anything moves, for A*'s estimate (it must never overestimate).
export const MAX_CAR_KMH = 120;
export const MAX_WALK_KMH = WALK_KMH / TRAIL_FACTOR;

export const MODES = ['car2', 'car4', 'walk'];

const kmh = (km) => km / 3.6; // m/s

/** Seconds to drive `metres` on an edge, for a car of `mode` ('car2'|'car4'). */
export function driveSeconds(metres, cls, surface, grade, mode) {
  let speed;
  if (cls === CLASS.track) {
    speed = mode === 'car2' ? 30 : TRACK_KMH_4X4[grade] ?? 12;
  } else {
    speed = ROAD_KMH[cls] || 20;
    if (surface >= SURFACE.gravel) speed = Math.min(speed, mode === 'car2' ? 30 : 40);
  }
  if (surface === SURFACE.sand) speed = Math.min(speed, 10);
  if (surface === SURFACE.rough) speed = Math.min(speed, 8);
  return metres / kmh(speed);
}

/** Seconds to walk `metres` on an edge. */
export function walkSeconds(metres, cls, sac, trail) {
  let speed = cls === CLASS.steps ? STEPS_KMH : WALK_KMH;
  let factor = 1;
  if (trail) factor *= TRAIL_FACTOR;
  if (cls <= CLASS.secondary) factor *= BUSY_ROAD_FACTOR;
  if (sac >= 2) factor *= 2;
  else if (sac === 1) factor *= 1.3;
  return (metres / kmh(speed)) * factor;
}

export const offTrailSeconds = (metres) => metres / kmh(OFFTRAIL_KMH);
